import { type PageContext, _ } from '@zto/zpage'
import { formatInter, formatPrice } from '@/utils/math'
// import type { App } from '@zto/zpage-runtime/dist/types/app/App'
import type { App } from '@zto/zpage'

// import { ZdsRefundStatus, ZdsRefundStatusOptions } from '@/pages/dms/zds/refund/config'
import {ZdsOrderStatus} from "@/pages/orderlist/config";
import {ZdsRefundStatus, ZdsRefundStatusOptions} from "@/pages/refund/config";
import dayjs from "dayjs";
// import { ZdsOrderStatus } from '@/pages/dms/zds/order/config'


/**
 * 查看详情
 */
export function getRefundDetailHandle() {
  return {
    dialog: ({ app }: PageContext) => {
      return {
        width: 1000,
        labelWidth: 100,
        title:'订单详情',
        itemSpan: 8,
        // noPadding: true,
        onShow: async ({ data }: PageContext) => {
          const { refundOrderNo } = data
          const result = await app.request({
            api: '/admin/refundOrder/queryRefundOrderDetail',
            params: {
              refundOrderNo
            }
          })
          return { payload: { ...data,...result } }
        },
        formItems: [
          { label: '订单编号', type: 'text', prop: 'orderId' },
          { label: '购买件数', type: 'text', prop: 'totalQuantity' },
          {
            label: '实付金额',
            type: 'html',
            html: ({ data }: PageContext) => {
              return `<div>${data.actualAmount}</div>`
            }
          },
          {
            label: '退款方式',
            type: 'html',
            html: ({ data }: PageContext) => {
              return `<div>${data.refundTypeDesc}</div>`
            }
          },
          { label: '退款件数', type: 'text', prop: 'totalQuantity' },
          {
            label: '退款金额',
            type: 'html',
            html: ({ data }: PageContext) => {
              return `<div>${data.refundAmount}</div>`
            }
          },
          { label: '退货单状态',
            type: 'html',
            html: ({ data }: PageContext) => {
              return `<div>${data.refundStatusDesc || '--'}</div>`
            }
          },
          { label: '退款金额是否修改', labelWidth:120, type: 'text', prop: 'returnModifyFlag' },
          { label: '退款原因', type: 'text', prop: 'refundReasonDesc' },
          { label: '申请时间', type: 'text', prop: 'applyTime' },
          {
            label: '是否已发货',
            type: 'html',
            html: ({ data }: PageContext) => {
              return `<div>${data.isShipped ? '是' : '否'}</div>`
            }
          },
          { label: '发货时间', type: 'text', prop: 'shipmentTime' },
          {
            label: '是否已签收',
            type: 'html',
            html: ({ data }: PageContext) => {
              return `<div>${data.isReceived ? '是' : '否'}</div>`
            }
          },
          {
            label: '是否已寄回',
            type: 'html',
            html: ({ data }: PageContext) => {
              return `<div>${data.isReturned ? '是' : '否'}</div>`
            }
          },
          { label: '寄回单号/公司',
            type: 'html',
            html: ({ data }: PageContext) => {
              return `<div>${data.returnLogisticsNo || '--'}/${data.returnLogisticsCompanyName || '--'}</div>`
            }
          },
          // {
          //   label: '退款备注',
          //   type: 'text',
          //   prop: 'returnExplain',
          //   span: 16,
          //   fullWidth: true
          // },
          {
            label: '退款备注',
            type: 'html',
            span: 24,
            fullWidth: true,
            html: ({ data }: PageContext) => {
              return `<div style="overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        white-space: normal;">
                          ${data.refundRemark || '--'}
                       </div>`
            }
          },
          { label: '收件人', type: 'text', prop: 'returnReceiverName' },
          { label: '联系方式', type: 'text', prop: 'returnReceiverPhone' },
          {
            label: '收件地址',
            type: 'html',
            span: 24,
            fullWidth: true,
            html: ({ data }: PageContext) => {
              return `<div style="overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        white-space: normal;">
                          ${data.returnReceiverAddress}
                       </div>`
            }
          },
          {
            label: '商品信息',
            labelWidth: 80,
            type: 'edit-table',
            prop: 'itemList',
            span: 24,
            noOperation: true,
            // disabled: isView,
            maxRows: 10,
            width: '100%',
            // required: true,
            autoHeight: true,
            columns: [
              { prop: 'spuCode', label: '商品编码', width: 200 },
              { prop: 'spuName', label: '商品名称', minWidth: 200 },
              { prop: 'refundQuantity', label: '退货数量', width: 100 },
              { prop: 'refundAmount', label: '退款金额',
                // formatter:(data: any) => {
                //   return formatPrice(data.payableAmount)
                // },
                width: 100
              },
              // { prop: 'ruleType', label: '按价格模糊查询', formatter: { name: 'enumStr', options: 'yesOrNo' }, width: 110 }
            ],
            // columns: [
            //   {
            //     prop: 'skuCode',
            //     label: '商品编码',
            //     minWidth: 100,
            //     editor: { itemType: 'text' }
            //   }
            // ],
            dynamicAttrs: ({ data }: PageContext) => {
              return { hidden:false }
            }
          },
        ],
        innerDialogs: {
          refundResolve: refundDialog().dialog,
          rejectResolve: rejectRefundDialog().dialog

        },
        actions: [
          {
            name: 'refundResolve',
            label: '通过',
            visibleOn: ({ data }: PageContext) => {
              return [ZdsRefundStatus.PENDING_FIRST_AUDIT,ZdsRefundStatus.PENDING_SELLER].includes(data.refundStatus);
            },
            trigger: ({ dialogExposed }: any) => {
              const { dataModel, showInnerDialog } = dialogExposed
              showInnerDialog('refundResolve', dataModel.value)
            }
          },
          {
            name: 'rejectResolve',
            label: '驳回',
            visibleOn: ({ data }: PageContext) => {
              return [ZdsRefundStatus.PENDING_FIRST_AUDIT,ZdsRefundStatus.PENDING_SELLER].includes(data.refundStatus);
            },
            trigger: ({ dialogExposed }: any) => {
              const { dataModel, showInnerDialog } = dialogExposed
              showInnerDialog('rejectResolve', dataModel.value)
            }
          },
          {
            label: '取消',
            name: 'close'
          }
        ]
      }
    }
  }
}


/**
 * 驳回退货单
 */
export function rejectRefundDialog() {
  return {
    dialog: ({ app }: PageContext) => {
      return {
        width: 600,
        title: '驳回退款',
        labelWidth: 80,
        itemSpan: 24,

        beforeSubmit: async ({ data }: PageContext, model: any, options: any) => {
          const {refundOrderNo,auditReason} = data
          const payload = {
            refundOrderNo,
            rejectionReason:auditReason,
            approved: false,
          }
          // await app.ui.showMessageBox({
          //   boxType: 'confirm',
          //   title: '确认退款',
          //   type: 'warning',
          //   showCancelButton: true,
          //   dangerouslyUseHTMLString:true,
          //   message: `
          //               <div>订单金额：<span style="color:#e6a23c; font-size: 20px; font-weight: bold">${formatPrice(totalPaymentAmount)}元</span></div>
          //               <div>退款金额：<span style="color:#f40; font-size: 20px; font-weight: bold">${returnAmount}元</span></div>
          //               <div>退款原因：${returnReason}</div>
          //           `
          // })

          return payload
        },
        onSubmit: async (payload: any, actionCfg: any, model: any, dialogExposed: any) => {
        // onSubmit: async ({ payload }: any) => {
          // if (!api) {
          //   app.ui.showMessage({ type: 'warning', content: '无效操作' })
          //   return
          // }
          // { soNo: '${data.row.soNo}', roNo: '${data.row.roNo}', action:'N' }

          await app.request({ api:'/admin/refundOrder/approveRefundOrder', data: { ...payload } })
          app.ui.showMessage({
            type: 'success',
            message: '操作成功，数据更新可能有延时，请稍后确认生效'
          })
          app.triggerPageSearch()
          dialogExposed.top?.close()
        },

        formItems: [
          { label: '驳回原因', type: 'textarea', autoHeight: true, prop: 'auditReason', minlength:2, maxlength: 200, required: true }
          // { label: '退款原因', type: 'input', prop: 'remark', required: true }
        ],
        // actions: [
        //   {
        //     name: 'submit',
        //     label: '通过',
        //   },
        //   { name: 'close' }
        // ]
      }
    }
  }

}

/**
 * 确认退款
 */
export function refundDialog() {
  return {
    dialog: ({ app }: PageContext) => {
      return {
        width: 800,
        labelWidth: 100,
        itemSpan: 24,
        title: '再次确认',

        onShow: async ({ data }: PageContext) => {
          const { orderId,refundOrderNo } = data

          const result = await app.request({
            api: '/admin/refundOrder/queryRefundOrderDetail',
            params: { refundOrderNo:refundOrderNo }
          })
          return {
            payload: {
              ...data,
              ...result,
              targetMoney: +formatPrice(data.returnTotalPaymentAmount, ''),
              originalReturnTotalPaymentAmount:+formatPrice(data.totalPayableAmount, '')
            }
          }
        },

        beforeSubmit: async ({ data }: PageContext, model: any, options: any) => {
          const {refundOrderNo,refundAmount} = data
          const payload = {
            refundOrderNo,
            refundAmount,
            approved: true,
          }
            // await app.ui.showMessageBox({
            //   boxType: 'confirm',
            //   type: 'warning',
            //   showCancelButton: true,
            //   message: '确认退款？'
            // })


          return payload
        },
        onSubmit: async (payload: any, actionCfg: any, model: any, dialogExposed: any) => {
          // if (!api) {
          //   app.ui.showMessage({ type: 'warning', content: '无效操作' })
          //   return
          // }



          await app.request({ api:'/admin/refundOrder/approveRefundOrder', data: { ...payload } })
          app.ui.showMessage({
            type: 'success',
            message: '操作成功，数据更新可能有延时，请稍后确认生效'
          })
          app.triggerPageSearch()
          dialogExposed.top?.close()
        },

        formItems: [
          { label: '订单编号', type: 'text', prop: 'orderId',  fullWidth: true },
          // { label: '商品名称', type: 'html', html: '${data.soNo}元商品名称元商品名称元商品名称元商品名称元商品名称元商品名称' , span: 16, fullWidth: true },
          // { label: '商品名称', type: 'text', tpl: '${data.soNo}元商品名称元商品名称元商品名称元商品名称元商品名称元商品名称' , span: 24, fullWidth: true },
          {
            label: '商品名称',
            type: 'html',
            span: 24,
            fullWidth: true,
            html: ({ data }: PageContext) => {
              return `<div style="overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;">
                        ${data.itemList[0]?.spuName || '--'}
                      </div>`
            }
          },
          { label: '购买件数', type: 'text', prop: 'totalQuantity' , span: 8 },
          {
            label: '实付金额',
            type: 'html',
            span: 8,
            html: ({ data }: PageContext) => {
              return `<div>${data.refundAmount}元</div>`
            }
          },
          {
            label: '退款方式',
            type: 'html',
            span: 8,
            html: ({ data }: PageContext) => {
              return `<div>${data.refundTypeDesc}</div>`
            }
          },
          // {
          //   label: '退款件数', type: 'html', span: 8,
          //   html: ({ data }: PageContext) => {
          //
          //     return `<div>${data.itemList[0].refundQuantity}</div>`
          //   }
          // },
          {
            label: '退款金额',
            type: 'html',
            span: 16,
            html: ({ data }: PageContext) => {
              return `<div>
                  ${data.itemList[0].refundPrice}元
                  ${ data.totalQuantity !== data.itemList[0].refundQuantity ? '<sapn style="padding-left: 20px; color:#f40">注：用户手动修改</sapn>' : ''}
                </div>`
            }
          },

          // {
          //   label: '上次修改金额',
          //   type: 'html',
          //   html: ({ data }: PageContext) => {
          //     return `<div>
          //         ${formatPrice(data.returnTotalPaymentAmount,'')}元
          //         <sapn style="padding-left: 20px; color:#f40">注：此为一审时修改的金额</sapn>
          //       </div>`
          //   },
          //   dynamicAttrs: ({ data }: PageContext) => {
          //     const showStatus = data.status === ZdsRefundStatus.THZ && data.returnTotalPaymentAmount !== data.totalPayableAmount
          //     return { hidden: !showStatus }
          //   }
          // },

          {
            label: '修改退款金额',
            type: 'input-number',
            prop: 'refundAmount',
            disabled:true,
            dynamicAttrs: ({ data }: PageContext) => {
              return {
                hidden:false,
                required: true,
                min: 0.01,
                max: data.originalReturnTotalPaymentAmount,
                precision: 2,
                disabled:true,
                // disabled: ZdsRefundStatus.COMPLETED === data.refundStatus
              }
            }
          },
          {
            label: '',
            type: 'html',
            span: 16,
            html: ({ data }: PageContext) => {
              const {refundStatus,refundType} = data
              let des = ''
              if (refundStatus === ZdsRefundStatus.PENDING_FIRST_AUDIT) {

                if (refundType === 1) {
                  des = '确认后将直接打款给用户'
                }else{
                  des = '确认后将要求买家上传快递单号'
                }

              }else if (refundStatus === ZdsRefundStatus.PENDING_SELLER) {
                des = '确认后将直接打款给买家'
              }
              return `<div style="color:red;">
                  ${des}
                </div>`
            }
          }
        ],
        // actions: [
        //   {
        //     name: 'submit',
        //     label: '通过',
        //   },
        //   { name: 'close' }
        // ]
      }
    }
  }

}




/**
 * 批量发货操作
 */
export function getRefundImgInfo() {
  return {
    label:'查看',
    dialog: ({ app }: PageContext) => {
      return {
        width: 800,
        labelWidth: 0,
        title:'补充材料详情',
        itemSpan: 0,
        // noPadding: true,
        onShow: async ({ data }: PageContext) => {
          const {refundOrderNo} = data
          const { returnImg } = data

          const mediaList = await _getPrivateReturnImgs(app ,refundOrderNo)
          return { payload: { ...data,mediaList } }
        },
        formItems: [
          {
            labelWidth:0,
            type: 'zds-refund-media',
            autoHeight: true,
            span: 24,
            dynamicAttrs: ({ data }: PageContext) => {
              return { hidden: false, required: false }
            }
          },
        ],
        actions: [
          {
            label: '取消',
            name: 'close'
          }
        ]
      }
    }
  }
}

async function _getPrivateReturnImgs( app:App, returnImg:string){
  try {
    // const data = JSON.parse(returnImg) || []
    let mediaList: any[] = []
    let result = await app.request({
      api: '/admin/refundOrder/queryRefundOrderDetail',
      params: {
        refundOrderNo: returnImg
      }
    }).catch(()=>{
      console.log('获取失败')
    })

    if(result?.materialList){
      mediaList = mediaList.concat(result.materialList)
    }
    return mediaList
  }catch (e){
    return []
  }
}



/**
 * 查看更多物流信息
 */
export function getMoreLogistics() {
  return {
    title: '物流详情',
    dialog: ({ app }: PageContext) => {
      return {
        onShow: async ({ data }: PageContext) => {
          return {
            payload: {
              ...data
            }
          }
        },
        width: 600,
        labelWidth: 80,
        itemSpan: 24,

        formItems: [
          {
            label: '订单编号',
            type: 'text',
            prop: 'soNo',
            dynamicAttrs: ({ data }: PageContext) => {
              return { hidden: false }
            }
          },
          {
            labelWidth: 0,
            prop: 'logisticsResList',
            type: 'combo',
            autoAppendFirst: true,
            maxlength:10,
            span: 24,
            autoHeight: true,
            noOperation: true,
            disabled: true,
            comboAttrs: {
              labelWidth: 120,
              header: {
                content: ({ data }: PageContext) => {
                  const ruleIndex = data.$index + 1
                  return {
                    html: `<b class="text-title">包裹信息${ruleIndex}</b>`
                  }
                }
              },
              footer: {
                style: { paddingLeft: '110px' }
              }
            },
            dynamicAttrs: ({ data: outerData }: PageContext) => {
              return {
                items: [
                  {
                    label: '物流公司',
                    type: 'select',
                    prop: 'companyTypeCode',
                    options: 'expressCompanyOpts',
                    span: 24,
                  },
                  {
                    label: '物流单号',
                    type: 'input',
                    prop: 'logisticsCode',
                    span: 24
                  }
                ]
              }
            }
          }
        ],

        actions: [
          { name: 'close' }
        ]
      }
    }
  }
}


